import './style.css'

/**
 * THE LINEAR OASIS — Interactive Application
 * Smooth scrolling, animations, counters, and mobile menu
 */

(function() {
  'use strict';

  // ========================================
  // DOM Elements
  // ========================================
  const navbar = document.getElementById('navbar');
  const mobileToggle = document.getElementById('mobileToggle');
  const mobileMenu = document.getElementById('mobileMenu');
  const mobileLinks = document.querySelectorAll('.mobile-link');
  const particlesContainer = document.getElementById('particles');

  // ========================================
  // Navbar Scroll Effect
  // ========================================
  function handleScroll() {
    const scrolled = window.scrollY > 80;
    navbar.classList.toggle('scrolled', scrolled);
  }
  window.addEventListener('scroll', handleScroll, { passive: true });
  handleScroll();

  // ========================================
  // Mobile Menu Toggle
  // ========================================
  function toggleMobileMenu() {
    const isActive = mobileMenu.classList.contains('active');
    mobileMenu.classList.toggle('active', !isActive);
    mobileToggle.classList.toggle('active', !isActive);
    document.body.style.overflow = isActive ? '' : 'hidden';
  }

  mobileToggle.addEventListener('click', toggleMobileMenu);

  mobileLinks.forEach(link => {
    link.addEventListener('click', () => {
      mobileMenu.classList.remove('active');
      mobileToggle.classList.remove('active');
      document.body.style.overflow = '';
    });
  });

  // ========================================
  // Smooth Scroll for Anchor Links
  // ========================================
  document.querySelectorAll('a[href^="#"]').forEach(anchor => {
    anchor.addEventListener('click', function(e) {
      const targetId = this.getAttribute('href');
      if (targetId === '#') return;
      const target = document.querySelector(targetId);
      if (target) {
        e.preventDefault();
        const offset = 80;
        const targetPosition = target.getBoundingClientRect().top + window.pageYOffset - offset;
        window.scrollTo({ top: targetPosition, behavior: 'smooth' });
      }
    });
  });

  // ========================================
  // Floating Particles
  // ========================================
  function createParticles() {
    if (!particlesContainer) return;
    const count = 18;
    for (let i = 0; i < count; i++) {
      const p = document.createElement('div');
      p.className = 'particle';
      p.style.left = Math.random() * 100 + '%';
      p.style.top = Math.random() * 100 + '%';
      p.style.width = (2 + Math.random() * 2) + 'px';
      p.style.height = p.style.width;
      p.style.opacity = 0.1 + Math.random() * 0.2;
      p.style.animationDelay = (Math.random() * 6) + 's';
      p.style.animationDuration = (5 + Math.random() * 7) + 's';
      particlesContainer.appendChild(p);
    }
  }
  createParticles();

  // ========================================
  // Scroll Reveal Animation
  // ========================================
  const revealElements = document.querySelectorAll('[data-reveal]');

  function checkReveal() {
    const windowHeight = window.innerHeight;
    const triggerOffset = windowHeight * 0.88;

    revealElements.forEach(el => {
      if (el.classList.contains('revealed')) return;
      const rect = el.getBoundingClientRect();
      if (rect.top < triggerOffset) {
        // Add stagger delay for children if it's a container
        const delay = el.dataset.delay || 0;
        setTimeout(() => {
          el.classList.add('revealed');
        }, parseInt(delay));
      }
    });
  }

  window.addEventListener('scroll', checkReveal, { passive: true });
  window.addEventListener('resize', checkReveal, { passive: true });
  // Initial check after a short delay
  setTimeout(checkReveal, 100);
  setTimeout(checkReveal, 500);

  // ========================================
  // Animated Number Counters
  // ========================================
  const counters = document.querySelectorAll('.counter');
  const counterObserver = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        const counter = entry.target;
        const target = parseInt(counter.dataset.target);
        animateCounter(counter, target);
        counterObserver.unobserve(counter);
      }
    });
  }, { threshold: 0.5 });

  counters.forEach(counter => counterObserver.observe(counter));

  function animateCounter(el, target) {
    const duration = 2000;
    const startTime = performance.now();

    function update(currentTime) {
      const elapsed = currentTime - startTime;
      const progress = Math.min(elapsed / duration, 1);
      // Ease out cubic
      const eased = 1 - Math.pow(1 - progress, 3);
      const current = Math.floor(eased * target);
      el.textContent = current.toLocaleString();

      if (progress < 1) {
        requestAnimationFrame(update);
      }
    }

    requestAnimationFrame(update);
  }

  // ========================================
  // Revenue Bar Animation
  // ========================================
  const revenueBars = document.querySelectorAll('.rev-bar-fill');
  const barObserver = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        const bar = entry.target;
        const width = bar.dataset.width;
        setTimeout(() => {
          bar.style.width = width + '%';
          bar.style.background = 'var(--color)';
        }, 200);
        barObserver.unobserve(bar);
      }
    });
  }, { threshold: 0.5 });

  revenueBars.forEach(bar => barObserver.observe(bar));

  // ========================================
  // Language Switcher
  // ========================================
  function initLangSwitcher(id) {
    const select = document.getElementById(id);
    if (!select) return;
    select.addEventListener('change', (e) => {
      const newLang = e.target.value;
      const path = location.pathname.replace(/^\/[a-z]{2}\//, '/');
      location.href = '/' + newLang + (path || '/');
    });
  }
  initLangSwitcher('langSelect');
  initLangSwitcher('langSelectMobile');

  // ========================================
  // Coming Soon Modal
  // ========================================
  const modal = document.getElementById('comingSoonModal');

  window.openComingSoonModal = function() {
    if (!modal) return;
    modal.classList.add('active');
    modal.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
    const emailInput = document.getElementById('modalEmail');
    if (emailInput) setTimeout(() => emailInput.focus(), 100);
  };

  window.closeComingSoonModal = function() {
    if (!modal) return;
    modal.classList.remove('active');
    modal.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
  };

  if (modal) {
    modal.addEventListener('click', (e) => {
      if (e.target === modal) closeComingSoonModal();
    });
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && modal.classList.contains('active')) {
        closeComingSoonModal();
      }
    });
  }

  // ========================================
  // API Helpers
  // ========================================
  async function postJSON(url, data) {
    const res = await fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(data)
    });
    const body = await res.json().catch(() => ({}));
    if (!res.ok) throw new Error(body.error || `HTTP ${res.status}`);
    return body;
  }

  function setBtnLoading(btn, loading) {
    if (!btn) return;
    if (loading) {
      btn.dataset.originalText = btn.innerHTML;
      btn.innerHTML = '<span style="display:inline-flex;align-items:center;gap:8px">Sending…</span>';
      btn.disabled = true;
      btn.style.opacity = '0.7';
    } else {
      btn.innerHTML = btn.dataset.originalText || btn.innerHTML;
      btn.disabled = false;
      btn.style.opacity = '';
    }
  }

  // ========================================
  // Contact Form
  // ========================================
  const contactForm = document.getElementById('contactForm');
  if (contactForm) {
    contactForm.addEventListener('submit', async (e) => {
      e.preventDefault();
      let valid = true;

      const name = document.getElementById('cf-name');
      const email = document.getElementById('cf-email');
      const phone = document.getElementById('cf-phone');
      const subject = document.getElementById('cf-subject');
      const message = document.getElementById('cf-message');

      // Clear errors
      ['cf-name-error', 'cf-email-error', 'cf-message-error'].forEach(id => {
        const el = document.getElementById(id);
        if (el) el.textContent = '';
      });

      if (!name || !name.value.trim()) {
        const err = document.getElementById('cf-name-error');
        if (err) err.textContent = 'Please enter your name.';
        valid = false;
      }
      if (!email || !email.value.trim() || !email.value.includes('@')) {
        const err = document.getElementById('cf-email-error');
        if (err) err.textContent = 'Please enter a valid email.';
        valid = false;
      }
      if (!message || !message.value.trim()) {
        const err = document.getElementById('cf-message-error');
        if (err) err.textContent = 'Please enter a message.';
        valid = false;
      }

      if (!valid) return;

      const btn = contactForm.querySelector('button[type="submit"]');
      setBtnLoading(btn, true);

      try {
        await postJSON('/api/contact', {
          name: name.value.trim(),
          email: email.value.trim(),
          phone: phone ? phone.value.trim() : '',
          subject: subject ? subject.value : 'investment',
          message: message.value.trim()
        });
        contactForm.classList.add('submitted');
        const success = document.getElementById('cf-success');
        if (success) success.classList.add('active');
      } catch (err) {
        const errEl = document.getElementById('cf-message-error');
        if (errEl) errEl.textContent = err.message || 'Failed to send. Please try again.';
      } finally {
        setBtnLoading(btn, false);
      }
    });
  }

  // ========================================
  // Modal Subscribe
  // ========================================
  window.handleModalSubscribe = async function(e) {
    e.preventDefault();
    const emailInput = document.getElementById('modalEmail');
    const email = emailInput.value.trim();
    if (!email || !email.includes('@')) return;

    const btn = e.target.querySelector('button[type="submit"]');
    setBtnLoading(btn, true);

    try {
      await postJSON('/api/subscribe', { email, source: 'modal' });
      const form = document.getElementById('modalSubscribeForm');
      const success = document.getElementById('modalSuccess');
      if (form) form.style.display = 'none';
      if (success) success.classList.add('active');
    } catch (err) {
      const note = document.querySelector('.modal-form-note');
      if (note) note.textContent = err.message || 'Failed to subscribe. Please try again.';
    } finally {
      setBtnLoading(btn, false);
    }
  };

  // ========================================
  // Inline Subscribe (below contact form)
  // ========================================
  window.handleInlineSubscribe = async function(e) {
    e.preventDefault();
    const emailInput = document.getElementById('inlineEmail');
    const email = emailInput.value.trim();
    if (!email || !email.includes('@')) return;

    const btn = e.target.querySelector('button[type="submit"]');
    setBtnLoading(btn, true);

    try {
      await postJSON('/api/subscribe', { email, source: 'inline' });
      const form = document.getElementById('inlineSubscribeForm');
      const note = form.nextElementSibling;
      const success = document.getElementById('inlineSubscribeSuccess');
      if (form) form.style.display = 'none';
      if (note) note.style.display = 'none';
      if (success) success.classList.add('active');
    } catch (err) {
      const note = document.querySelector('.subscribe-inline-note');
      if (note) {
        note.textContent = err.message || 'Failed to subscribe. Please try again.';
        note.style.color = 'var(--coral-blush)';
      }
    } finally {
      setBtnLoading(btn, false);
    }
  };

  // ========================================
  // Download Deck Handler (opens modal)
  // ========================================
  window.downloadDeck = function() {
    openComingSoonModal();
  };

})();
